import { SyncStatus } from "@/components/sync";
import { useAppStore } from "@/store";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { MenuItem } from "react-aria-components";

export const SidebarDropdownSyncStatus = observer(function SidebarDropdownSyncStatus() {
  const { store } = useAppStore();
  const { syncState } = store.sync;
  return (
    <StyledSyncStatusMenuItem>
      <SyncStatus syncState={syncState} />
    </StyledSyncStatusMenuItem>
  );
});

const StyledSyncStatusMenuItem = styled(MenuItem)`
  grid-column: 1 / -1;
`;
